import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { Permission, requestPermission } from '@utils/nativeUtils';
import { useTranslation } from 'react-i18next';

import contactImportIcon from './ic_contact_import.svg';
import phoneLineIcon from './ic_phone_mobile.svg';

declare module '@stackflow/config' {
    interface Register {
        ContactMethodBottomSheet: {};
    }
}

const ContactMethodBottomSheet: ActivityComponentType<'ContactMethodBottomSheet'> = () => {
    const { t } = useTranslation('gift');
    const { pop, replace } = useFlow();

    return (
        <BottomSheet>
            <Container fullWidth align='center' role='dialog' aria-modal='true'
                aria-labelledby='contact-method-title'>
                <Title id='contact-method-title' size='title' fontWeight='bold' align='center'>
                    {t('giftOrder.contactMethod.title')}
                </Title>
                <Options fullWidth spacing={2}>
                    <OptionButton type='button' onClick={() => {
                        pop();
                        // 연락처 결과(setContacts)는 GiftOrderActivity 의 Receiver(useContact)가 받는다.
                        requestPermission(Permission.READ_CONTACT);
                    }}>
                        <IconWrapper><img src={contactImportIcon} width={20} height={18} alt='' /></IconWrapper>
                        <Text fontWeight='bold' color={colors.textSecondary}>
                            {t('giftOrder.contactMethod.import')}
                        </Text>
                    </OptionButton>
                    <OptionButton type='button' onClick={() => replace('GiftAddContactActivity', {})}>
                        <IconWrapper><img src={phoneLineIcon} width={24} height={24} alt='' /></IconWrapper>
                        <Text fontWeight='bold' color={colors.textSecondary}>
                            {t('giftOrder.contactMethod.manual')}
                        </Text>
                    </OptionButton>
                </Options>
                <Actions><Button type='button' fullWidth onClick={() => pop()}>
                    {t('giftOrder.contactMethod.close')}
                </Button></Actions>
            </Container>
        </BottomSheet>
    );
};

const Container = styled(Column)`
    border-radius: 16px 16px 0 0;
    background: ${colors.white};
`;

const Options = styled(Column)`
    padding: var(--spacing-4);
`;

const OptionButton = styled.button`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: var(--spacing-2);
    height: 50px;
    padding: 0 var(--spacing-5);
    border: 1px solid ${colors.gray2};
    border-radius: 16px;
    background: ${colors.white};
    cursor: pointer;
`;

const Title = styled(Text)`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    width: 100%;
`;

const Actions = styled.div`
    width: 100%;
    padding: var(--spacing-4);
`;

const IconWrapper = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
`;

export default ContactMethodBottomSheet;
